export default [
  { class_type: 'Economy', class_text: 'Economy' },
  { class_type: 'PremiumEconomy', class_text: 'Economy Premium' },
  { class_type: 'Business', class_text: 'Business' },
  { class_type: 'First', class_text: 'First' }
]
